import { useGetCargosSummary } from 'api/cargos/use-get-cargos-summary.ts';
import { useCargoFiltersStore } from 'shared/stores/use-cargo-filters.ts';
import { numberFormatter } from 'shared/utils/numbers/formatter';
import { ListSummary } from 'components/common/list-summary';
import styles from './cargos-summary.module.scss';

export const CargosSummary = () => {
  const { filters, search } = useCargoFiltersStore();
  const { data, isLoading } = useGetCargosSummary({ search, filters });

  return (
    <ListSummary isLoading={isLoading} className={styles.halfWidth}>
      Count: {numberFormatter(data?.count || 0)} / LDM: {numberFormatter(data?.totalLDM || 0)} / Total weight:{' '}
      {numberFormatter(data?.totalWeight || 0)}
      <br />
      Avg. transit time: {data?.avgTransitTime}h; Our Customs: EX: {numberFormatter(data?.ourCustoms.EX || 0)}; CDS:{' '}
      {numberFormatter(data?.ourCustoms.CDS || 0)}
    </ListSummary>
  );
};
